import { useRef } from 'react';
import type { FilterKeys } from '../types';

export default function useDependencyCollection() {
  const dependencyCollectionCallback = useRef<{
    [key: string]: {
      deps: Array<FilterKeys>;
      callback: (value: any) => void;
    };
  }>({});

  const collectionCallback = (
    key: string,
    callback: (value: any) => void,
    deps: Array<FilterKeys>,
  ) => {
    dependencyCollectionCallback.current[key] = {
      deps,
      callback,
    };
  };

  const triggerCollectionCallback = (key: FilterKeys, valueInfo: any) => {
    // console.log(dependencyCollectionCallback.current, key);
    for (const collectionKey in dependencyCollectionCallback.current) {
      const { callback, deps } =
        dependencyCollectionCallback.current[collectionKey];
      if (deps.includes(key)) {
        callback(valueInfo.value);
      }
    }
  };

  return {
    triggerCollectionCallback,
    collectionCallback,
  };
}
